"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenseModel = void 0;
const licenseConstants_json_1 = __importDefault(require("../constants/licenseConstants.json"));
const SkelloLicenseModel_1 = require("../Model/SkelloLicenseModel");
class LicenseModel {
    constructor(props) {
        Object.assign(this, props);
    }
    static fromJSON(props) {
        const permissions = SkelloLicenseModel_1.SkelloLicenseModel.fromBin(props.permissions);
        return new LicenseModel({
            clusterNodeIds: props.cluster_node_ids.map((nodeId) => nodeId + ''),
            name: props.name,
            permissions,
            shopIds: props.shop_ids.map((id) => id + ''),
        });
    }
}
exports.LicenseModel = LicenseModel;
_a = LicenseModel;
LicenseModel.licenseHierarchy = licenseConstants_json_1.default.licenseHierarchy;
LicenseModel.getAggregatedLicenses = (licenses) => {
    const aggregatedLicenses = {};
    licenses.forEach((license) => {
        Object.keys(license.permissions).forEach((licensePermission) => {
            const value = license.permissions[licensePermission];
            if (value) {
                aggregatedLicenses[licensePermission] = value;
            }
        });
    });
    return aggregatedLicenses;
};
LicenseModel.getHighestLicense = (licenses) => {
    let highestLicense = {
        originalType: '',
        permissions: {},
        position: Math.max(...Object.values(_a.licenseHierarchy)),
    };
    licenses.forEach((license) => {
        license.shopIds.forEach(() => {
            const isHigherLicense = highestLicense.originalType === '' ||
                _a.licenseHierarchy[license.name] < _a.licenseHierarchy[highestLicense.originalType];
            if (isHigherLicense) {
                highestLicense = {
                    originalType: license.name,
                    permissions: license.permissions,
                    position: _a.licenseHierarchy[license.name],
                };
            }
        });
    });
    return highestLicense;
};
LicenseModel.getUserLicenseForShop = (licenses) => {
    const userLicenseForShop = {};
    const skelloLicenses = licenses.filter((license) => Object.keys(_a.licenseHierarchy).includes(license.name));
    const servicesLicenses = licenses.filter((license) => !Object.keys(_a.licenseHierarchy).includes(license.name));
    skelloLicenses.forEach((license) => {
        license.shopIds.forEach((shopId) => {
            const isHigherLicenseForShop = !userLicenseForShop[shopId] ||
                _a.licenseHierarchy[license.name] < _a.licenseHierarchy[userLicenseForShop[shopId].originalType];
            if (isHigherLicenseForShop) {
                userLicenseForShop[shopId] = {
                    originalType: license.name,
                    permissions: license.permissions,
                    position: _a.licenseHierarchy[license.name],
                };
            }
        });
    });
    // Manually merge permissions coming from not-skello licenses in the user license for shop mapping.
    // (e.g. microservices permissions, only time_clock_license, see in jwt_token_service, at the time of writing this comment).
    // This is required as not-skello licenses are not listed in user license hierarchy.
    servicesLicenses.forEach((license) => {
        license.shopIds.forEach((shopId) => {
            if (!userLicenseForShop[shopId]) {
                userLicenseForShop[shopId] = {
                    originalType: license.name,
                    permissions: license.permissions,
                    position: _a.licenseHierarchy[license.name],
                };
                return;
            }
            const skelloPermissions = userLicenseForShop[shopId]?.permissions;
            const servicePermissions = license.permissions;
            const mergedPermissions = Object.keys(skelloPermissions).reduce((_mergedPermissions, permission) => {
                _mergedPermissions[permission] = skelloPermissions[permission] || servicePermissions[permission];
                return _mergedPermissions;
            }, {});
            userLicenseForShop[shopId].permissions = mergedPermissions;
        });
    });
    return userLicenseForShop;
};
LicenseModel.getUserLicenseForCluster = (licenses) => {
    const userLicenseForCluster = {};
    licenses.forEach((license) => {
        license.clusterNodeIds.forEach((clusterNodeId) => {
            const isHigherLicenseForCluster = !userLicenseForCluster[clusterNodeId] ||
                _a.licenseHierarchy[license.name] <
                    _a.licenseHierarchy[userLicenseForCluster[clusterNodeId].originalType];
            if (isHigherLicenseForCluster) {
                userLicenseForCluster[clusterNodeId] = {
                    originalType: license.name,
                    permissions: license.permissions,
                    position: _a.licenseHierarchy[license.name],
                };
            }
        });
    });
    return userLicenseForCluster;
};
LicenseModel.serializeLicenses = (licenses) => {
    if (!licenses) {
        return {
            aggregatedLicenses: {},
            highestLicense: {
                originalType: '',
                permissions: {},
                position: 0,
            },
            userLicenseForCluster: {},
            userLicenseForShop: {},
        };
    }
    const licensesInstance = licenses.map((licence) => _a.fromJSON(licence));
    return {
        aggregatedLicenses: LicenseModel.getAggregatedLicenses(licensesInstance),
        highestLicense: LicenseModel.getHighestLicense(licensesInstance),
        userLicenseForCluster: LicenseModel.getUserLicenseForCluster(licensesInstance),
        userLicenseForShop: LicenseModel.getUserLicenseForShop(licensesInstance),
    };
};
//# sourceMappingURL=LicenseModel.js.map